import { useEffect, useState } from "react";
import { Generico } from "../../components/Generico";
import { Causa } from "../../models/riesgo/Causa";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { Dialog } from "primereact/dialog";
import { Criterios } from "./Criterios";

export const CausaRiesgo = ({ generic, permss, toast, riesgo, id, catalogo, funcionalidades }) => {

    const omodel = new Causa();
    const matrizSrv = new MonitoreoService();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model, null);
    const [registros, setRegistros] = useState(null);
    const [item, setItem] = useState(null);
    const [dialogCriterio, setDialogCriterio] = useState(false);
    const [dialogCausa, setDialogCausa] = useState(false);
    const [catalogos, setCatalogos] = useState(null);
    const [titulo, setTitulo] = useState(null);
    const [campo, setCampo] = useState(null);
    const [tipo, setTipo] = useState(null);
    const [listar, setListar] = useState(null);
    const [seleccionar, setSeleccionar] = useState(false);
    const [load, setLoad] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const { table, setLoading, setTotalRecords, lazyParams, inDrop } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const funcionalidadPorTipo = {
        MTR_RIESGO_CAUSA_RIESGO: 'MATRIZ-RIESGOS-CRUD-CAUSA-RIESGO', // DEBE SER IGUAL AL DE CRITERIOS.JSX
    };

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.idp = id;
        _lazyParams.matrizId = riesgo?.id;
        matrizSrv.listado('matriz-riesgo-causa/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setCatalogos(res.data?.catalogos);
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogCausa(true);
    }

    const onSubmit = (data) => {
        data.idp = id;
        setLoad(true);
        if (getValues('id') == null) {
            matrizSrv.nuevo(data, 'matriz-riesgo-causa/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogCausa(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
        else {
            matrizSrv.editar(data, 'matriz-riesgo-causa/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogCausa(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
    }

    const editar = () => {
        matrizSrv.consultar(`${item?.id}/${id}`, 'matriz-riesgo-causa/consulta').then(res => {
            const _riesgo = res.data;
            reset(generic.renewValues(_riesgo, omodel.model));
            setDialogCausa(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            group: 'eliminar-riesgo',
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    }

    const eliminar = () => {
        matrizSrv.eliminar(`${item?.id}/${id}`, 'matriz-riesgo-causa/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    }

    const itemsMenu = () => {
        const items = [];
        const funcionalidadRequerida = funcionalidadPorTipo['MTR_RIESGO_CAUSA_RIESGO'];
        if (permss?.actualizar && siOpcion(funcionalidadRequerida))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() } });
        if (permss?.eliminar && siOpcion(funcionalidadRequerida))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const customDialogHeader = () => {
        return (
            <div>
                <i className="pi pi-user-edit icon-header" />
                <span className="title-header">
                    {getValues('id') == null ? " Nuevo " : " Editar "}
                </span>
            </div>
        );
    }

    const headerTemplate = (options) => {
        const funcionalidadRequerida = funcionalidadPorTipo['MTR_RIESGO_CAUSA_RIESGO'];
        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    {permss?.crear && siOpcion(funcionalidadRequerida) && <Button icon="pi pi-search-plus" className="p-button-rounded p-button-success mr-2" type="button" onClick={openNew} tooltip="Añadir causa del riesgo" />}
                </div>
            </div>
        );
    }

    const criterios = (opc, ccampo, lis = 'solo', sel = false) => {
        setTitulo(omodel?.model[ccampo]?.header);
        setCampo(ccampo);
        setTipo(opc);
        setDialogCriterio(true);
        setSeleccionar(sel);
        setListar(lis);
    }

    const seleccion = (info, listado) => {
        if (listar === 'solo') {
            // const _catalogos = catalogos;
            // _catalogos[tipo] = listado;
            // setCatalogos(_catalogos);
            loadLazyData(); // Actualizamos el registro en la tabla
        } else {
            setValue(campo, info);
            setDialogCriterio(false);
            setTipo(null);
            setSeleccionar(null);
            setListar(null);
        }
    }

    return (
        <>
            <Panel headerTemplate={headerTemplate}>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Panel>

            <Dialog visible={dialogCausa} header={customDialogHeader} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogCausa(false);
            }}
                style={{ width: '400px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inDrop('causa', catalogos?.MTR_RIESGO_CAUSA_RIESGO, { lab: 'nombre' }, 11)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', paddingTop: '1.85rem' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Registrar y Buscar"
                                onClick={() => criterios('MTR_RIESGO_CAUSA_RIESGO', 'causa')} />
                        </div>
                    </div>
                    {generic.buttonsForms(setDialogCausa, load)}
                </form>
            </Dialog>

            <Dialog visible={dialogCriterio} header={titulo} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogCriterio(false);
            }}
                style={{ maxWidth: '500px' }}>
                <Criterios toast={toast} permss={permss} generic={generic} riesgo={riesgo} tipo={tipo} seleccion={seleccion} seleccionar={seleccionar} listar={listar} funcionalidades={funcionalidades} />
            </Dialog>
        </>
    )
}

